module.exports = {"data":{"site":{"siteMetadata":{"title":"Gatsby + Netlify CMS Starter"}},"allMarkdownRemark":{"totalCount":1,"edges":[{"node":{"fields":{"slug":"/blog/2017-01-05-using-git-for-docs/"},"frontmatter":{"title":"Using Git for Docs"}}}]}},"pathContext":{"tag":"docs"}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/tags-docs.json
// module id = 362
// module chunks = 263910457428570